import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_STRUTTURE } from '../queries/strutture';

export const fetchStrutture = async (where) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const result = await graphQlClient.query({
      variables: { where },
      query: FETCH_STRUTTURE,
    });

    return result.data.struttures.edges.map((edge) => edge.node);
  } catch (error) {
    console.error('[fetchStrutture] Error:', error);
    return [];
  }
};
